import { useMutation, useQueryClient } from '@tanstack/react-query';
import { accountSpendingApi } from '../services/api';
import type { UpdateAccountSpendingInput } from '../types/billing';
import { ACCOUNT_USAGE_QUERY_KEY } from './useAccountUsage';

/**
 * Save the account's spending limit, alert thresholds and hard stop
 * (task 1159 → `PATCH /api/accounts/spending`, service task 1156).
 *
 * There is no separate read: the setting and this month's reading ride the
 * usage summary's `spending` block, so a successful save refetches that shared
 * query and every spending surface (the page, Billing, Dashboard, top bar,
 * banners) picks up the new limit from one snapshot.
 */
export const useUpdateAccountSpending = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateAccountSpendingInput) =>
      accountSpendingApi.update(data).then((res) => res.data.data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ACCOUNT_USAGE_QUERY_KEY }),
  });
};
